import React, { useState, useEffect } from "react";
import { Tag, Calendar, AlertCircle, ChevronRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCoupons } from "../../server/Coupon";
import { useSelector } from "react-redux";
import {
  clearCouponReturn,
  isCouponCheckoutReturn,
} from "../../utils/couponNavigation";

const CostumerCoupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useSelector((state) => ({
    user: state.user.user,
  }));

  const fromCheckout = isCouponCheckoutReturn(location);

  const handleExit = () => {
    clearCouponReturn();
    navigate("/cart");
  };

  useEffect(() => {
    if (!fromCheckout) return;
    return () => {
      clearCouponReturn();
    };
  }, [fromCheckout]);

  useEffect(() => {
    if (!user?.email) return;
    getCoupons()
      .then((res) => {
        setCoupons(res.filter((c) => c.EmailAddress === user.email));
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, [user?.email]);

  useEffect(() => {
    if (loading || window.location.hash !== "#coupons") return;
    const section = document.getElementById("coupons");
    if (!section) return;
    requestAnimationFrame(() => {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [loading]);

  return (
    <div id="coupons" className="details-window">
      <div className="header-window">
        <h2>הקופונים שלי</h2>
        {fromCheckout ? (
          <button
            type="button"
            className="coupons-exit-btn"
            onClick={handleExit}
          >
            <ChevronRight size={16} strokeWidth={2.5} aria-hidden />
            חזרה להמשך ההזמנה
          </button>
        ) : null}
      </div>

      <div className="coupons-container">
        {loading ? (
          <div className="loading-message">טוען קופונים...</div>
        ) : coupons.length === 0 ? (
          <div className="empty-message">
            <AlertCircle size={40} strokeWidth={1.5} />
            <p>אין קופונים זמינים כרגע</p>
          </div>
        ) : (
          <div className="coupons-list">
            {coupons.map((coupon) => (
              <div
                key={coupon.Id}
                className={`coupon-card ${!coupon.Active ? "inactive" : ""}`}
              >
                <div className="coupon-header">
                  <div className="coupon-badge">
                    <Tag size={18} strokeWidth={2} />
                    <span className="discount-text">{coupon.Sum} ₪</span>
                  </div>
                  <div className="coupon-status">
                    {coupon.Active ? (
                      <span className="status-active">פעיל</span>
                    ) : (
                      <span className="status-inactive">פג תוקף</span>
                    )}
                  </div>
                </div>

                <div className="coupon-body">
                  <div className="coupon-code">{coupon.CouponCode}</div>
                  <span className="coupon-description">
                    למימוש החל מ-{coupon.MinOrder} ₪
                  </span>
                </div>

                <div className="coupon-footer">
                  <Calendar size={14} strokeWidth={2} />
                  <span className="expiry-text">
                    בתוקף עד:{" "}
                    {new Date(coupon.ExpiredDate).toLocaleDateString("he-IL")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CostumerCoupons;
